import { z } from 'zod';
import { LAYOUT_PRESETS } from '../constants.ts';
import { idSchema, unixMsSchema } from './common.ts';

// Layouts (Sprint 9, docs/09 §C1): a named preset + a zone → playlist assignment for
// every NON-main zone (main stays schedule-resolved; see docs/02 §Resolver semantics).
// Assigned to a screen via screens.layout_id; NULL/dangling falls back to fullscreen.

export const layoutPresetSchema = z.enum(LAYOUT_PRESETS);

// zones_json: non-main zone id -> playlist id. 'main' never appears here.
export const layoutZonesSchema = z.object({
  side: idSchema.optional(),
  ticker: idSchema.optional(),
});
export type LayoutZones = z.infer<typeof layoutZonesSchema>;

export const layoutSchema = z.object({
  id: idSchema,
  org_id: idSchema,
  name: z.string().min(1),
  preset: layoutPresetSchema,
  zones: layoutZonesSchema,
  created_at: unixMsSchema,
});
export type Layout = z.infer<typeof layoutSchema>;

// POST /v1/layouts — zones must exactly match the preset's non-main zones (validated
// in the service, not the schema, so a preset mismatch reports a clear message).
export const createLayoutSchema = z.object({
  name: z.string().min(1),
  preset: layoutPresetSchema,
  zones: layoutZonesSchema,
});
export type CreateLayout = z.infer<typeof createLayoutSchema>;

// PATCH /v1/layouts/:id — name and/or zones; preset is fixed at creation.
export const updateLayoutSchema = z
  .object({
    name: z.string().min(1).optional(),
    zones: layoutZonesSchema.optional(),
  })
  .refine((v) => Object.keys(v).length > 0, { message: 'provide at least one field' });
export type UpdateLayout = z.infer<typeof updateLayoutSchema>;
